/**
 * Gauntlet Debates - A platform for structured, AI-moderated honorable debates
 * Copyright (c) 2025 Gauntlet Debates. All rights reserved.
 * 
 * This file is part of the Gauntlet Debates platform and is protected by 
 * copyright and other intellectual property laws. Unauthorized reproduction,
 * distribution, or disclosure of this file or its contents is prohibited.
 */
import React from 'react';
import { Container } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import BetaTesterBanner from './BetaTesterBanner';

interface PageLayoutProps {
  children: React.ReactNode;
  showBanner?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  showBanner = true, 
  maxWidth = 'lg' 
}) => {
  return (
    <>
      <Header />
      {showBanner && (
        <Container maxWidth={maxWidth} sx={{ mt: 2 }}>
          <BetaTesterBanner />
        </Container>
      )}
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </>
  );
};

export default PageLayout; 